var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"draggableContainer",staticClass:"draggable-container"},[_c('div',{attrs:{"id":"draggable-header"},on:{"mousedown":_vm.dragMouseDown}},[_vm._t("header")],2),_c('div',{attrs:{"id":"draggable-inner-overlay"}}),_vm._t("main"),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }